import AddIcon from "@mui/icons-material/Add";
import { Box, IconButton, Typography } from "@mui/material";
import { memo } from "react";
import { Neutrals } from "../../../../../core-components/theme/color-palette/colors";
import { EscalationGroup } from "../../../types";
import EscalationGroupRow from "./EscalationGroupRow";

interface EscalationGroupsSectionProps {
  escalationGroups: EscalationGroup[];
  errors: { [key: string]: { users?: string; time?: string } };
  onUpdateEscalationGroup: (groupId: string, updates: Partial<EscalationGroup>) => void;
  onAddEscalationGroup: () => void;
  onRemoveEscalationGroup: (groupId: string) => void;
  options: any
}

const EscalationGroupsSection = memo(
  ({
    escalationGroups,
    errors,
    onUpdateEscalationGroup,
    onAddEscalationGroup,
    onRemoveEscalationGroup,
    options
  }: EscalationGroupsSectionProps) => {

    if (escalationGroups.length === 0) {
      return (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
          border: '1px dashed',
          borderColor: 'divider',
          borderRadius: 2,
          minHeight: '150px'
        }}>
          <IconButton
            title="Add New Escalation Group"
            onClick={onAddEscalationGroup}
            size="small"
            sx={{
              width: 42,
              height: 42,
              backgroundColor: Neutrals[50],
              "&:hover": { backgroundColor: "#E0E0E0" },
            }}
          >
            <AddIcon fontSize="medium" />
          </IconButton>
          <Typography variant="body1" color="text.secondary" mb={2}>
            Add New Escalation Group
          </Typography>
        </Box>
      );
    }

    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {escalationGroups.map((group, index) =>
          <EscalationGroupRow
            key={group.id}
            options={options}
            group={group}
            index={index}
            errors={errors[group.id] || {}}
            canRemove={escalationGroups.length > 1}
            onUpdate={onUpdateEscalationGroup}
            onRemove={onRemoveEscalationGroup}
          />
        )}
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 2,
          pb: 2,
        }}>
          <IconButton
            title="Add New Escalation Group"
            onClick={onAddEscalationGroup}
            size="small"
            sx={{
              width: 42,
              height: 42,
              backgroundColor: Neutrals[50],
              "&:hover": { backgroundColor: "#E0E0E0" },
            }}
          >
            <AddIcon fontSize="medium" />
          </IconButton>
        </Box>
      </Box>
    );
  },
);

export default EscalationGroupsSection;